/** AY custom dimension carrying `<targetingKey>-<typeTag6>`, withheld until identifier consent. */
export const USER_ID_DIMENSION = 'custom_8'

/** AY custom dimension packing `<lastEngagementAction>:<daysSinceLastEngagement>:<daysSinceInstall>`. */
export const ENGAGEMENT_DIMENSION = 'custom_10'

/** AY custom dimension carrying the raw consent state for reporting splits. */
export const CONSENT_STATE_DIMENSION = 'custom_15'

/** AY `layout`: `<cohort>:<splittestname>`, or the bare split test when no cohort is known. */
export function packLayout(
  cohort: string | null,
  splitTestName: string
): string {
  return cohort ? `${cohort}:${splitTestName}` : splitTestName
}

/**
 * ENGAGEMENT_DIMENSION value. Parts stay positional, an unknown one is empty
 * (`search:0:183`, `::183`), so reports can split on `:`. Null when nothing is known.
 */
export function packEngagement(
  lastEngagementAction: string | null,
  daysSinceLastEngagement: number | null,
  daysSinceInstall: number | null
): string | null {
  const parts = [
    lastEngagementAction,
    daysSinceLastEngagement,
    daysSinceInstall,
  ]
  if (parts.every((part) => part === null)) return null
  return parts.map((part) => (part === null ? '' : String(part))).join(':')
}
